import { handleActions } from 'redux-actions';
import jwtDecode from 'jwt-decode';

export default handleActions(
  {
    AUTH_SUCCESS: (state, action) => {
      const decoded = jwtDecode(action.payload.token);
      return { token: action.payload.token, user: decoded, isAuthenticated: true };
    },
    AUTH_LOGOUT: () => {
      localStorage.removeItem('token');
      return { isAuthenticated: false };
    },
  },
  { isAuthenticated: false },
);
